module.exports = __webpack_public_path__ + "static/img/chain-node-num.241a94d1.png";